<template>
    <div class="mediver-register-container nb">
        <div class="mediver-login-logo">
            <img src="@/assets/resource/icon/hover_logo.png" alt="Electroceuticals" class="login-logo-img" />
            <div class="sub-title">아이디 찾기</div>
        </div>
        <form class="register-box" @submit.prevent="findId" v-if="mode == 'input'">
            <div class="find-row">
                <label class="find-label" for="hospitalCode">병원코드</label>
                <input id="hospitalCode" class="find-input" v-model="hospitalCode" placeholder="병원 코드" autocomplete="hospitalCode" maxlength="100" @keydown.space.prevent/>
            </div>
            <div class="find-row">
                <label class="find-label" for="name">이름</label>
                <input id="name" class="find-input" v-model="name" placeholder="이름 (실명)" autocomplete="name" maxlength="10" @keydown.space.prevent/>
            </div>
            <div class="find-row">
                <label class="find-label" for="phone">전화번호</label>
                <input id="phone" class="find-input" v-model="phone" placeholder="휴대폰 번호" autocomplete="tel" maxlength="20" @keydown.space.prevent  @input="filterPhone"/>
            </div>
            <div class="popup-btn-group">
                <button type="submit" class="blue-btn">아이디 찾기</button>
            </div>
            <div class="register-links">
                <span class="link" @click="$emit('toLogin')">로그인 화면</span>
                <span class="divider">|</span>
                <span class="link" @click="$emit('toResetPassword')">비밀번호 찾기</span>
                <span class="divider">|</span>
                <span class="link" @click="$emit('toRegister')">회원가입</span>
            </div>
        </form>
        <div class="register-result-box" v-if="mode == 'result'">
            <div v-if="result" class="login-error" style="color: #1976d2;">{{ result }}</div>
            <div v-if="error" class="login-error">{{ error }}</div>
            <div class="popup-btn-group">
                <button type="button" class="blue-btn" @click="mode = 'input'">확인</button>
            </div>
        </div>
    </div>
</template>
<script>
    import api, {urls} from '@/api'
    import { useAppAlert }  from '@/composables/useAppAlert';

    const { showAlert, showAlertAndMove, confirm } = useAppAlert()

    export default {
        name: 'ID',
        data() {
            return {
                hospitalCode: '',
                name: '',
                phone: '',
                result: '',
                error: '',
                mode: 'input'
            };
        },
        methods: {
            async findId() {
                if (!this.hospitalCode) {
                    showAlert("병원코드를 입력해주세요.");
                    return;
                }
                if (!this.name) {
                    showAlert("이름을 입력해주세요.");
                    return;
                }
                if (!this.phone) {
                    showAlert("휴대폰 번호를 입력해주세요.");
                    return;
                }
                this.result = ''
                this.error = ''
                api.post(urls.login.findID, {
                    instCd: this.hospitalCode,
                    name: this.name,
                    phone: this.phone 
                }).then(response => {
                    const res = response.data;

                    if (res.error) {
                        // 실패 시 메시지 표시
                        this.error = res.error || '등록된 정보가 없습니다. 다시 한 번 확인해주세요.';
                    } else {
                        // 성공 시 아이디 결과를 화면에 표현
                        this.result = `회원님의 아이디는 "${res.email}" 입니다.`;
                    }
                    this.mode = 'result'
                }).catch(err => {
                    this.error = '아이디 찾기 중 오류가 발생했습니다.';
                    this.mode = 'result'
                });
            },
            filterPhone(event){
                event.target.value = event.target.value.replace(/[^0-9-]/g, '');
                this.phone = event.target.value;
            }
        }
    };
</script>